import * as React from 'react';
import { cn } from '../../lib/shadcn-utils';

const NativeSelect = React.forwardRef(({ className, ...props }, ref) => (
  <select ref={ref} className={cn(className)} {...props} />
));
NativeSelect.displayName = 'NativeSelect';

export { NativeSelect };

